import { calcGrowth } from 'utils/calc';

export class MeasureComparisonUtil {
  static calcValue(value: number, comparisonValue: number | undefined): number | undefined {
    if (comparisonValue === undefined) {
      return undefined;
    }
    return value - comparisonValue;
  }

  static calcPercentage(value: number, comparisonValue: number | undefined, useCalcGrowth = false): number | undefined {
    if (comparisonValue === undefined) {
      return undefined;
    }
    return useCalcGrowth ? calcGrowth(value, comparisonValue) : (value - comparisonValue) / comparisonValue;
  }
}
